<template>

	<div>

		<v-card elevation="0">
			<v-card-text>

				<v-card v-if="campagna != null" class="card-section">
					<!--nome-->
					<v-card-title>{{campagna.titolo}}</v-card-title>
					
					<!-- <v-divider class="mx-4 mb-3"></v-divider>
					<v-subheader class="pb-1 details-campagna">Dettagli</v-subheader> -->
					
					<v-card-text class="pt-0"> 
						<div class="details-campagna-desc"><b>Descrizione: </b>{{campagna.descrizione}}</div>
					</v-card-text>
					
				</v-card>

				<v-card class="card-section">
					<MiniMappa class="minimappa"
						v-if="configurazioneMappa != null"
						v-on:update-selection="selezioneMappa = $event"
						v-bind:prop_configuration="configurazioneMappa"
						v-bind:prop_layer_features="quadrounione_features"
						v-bind:prop_selected_layer_features="filtro_grid_codici_selezionati">
					</MiniMappa>
					<div v-if="debugEnabled">
						Selezione mappa: {{selezioneMappa}}
						Filtro grid: {{filtro_grid}}
						Filtro grid codici selezionati per  mappa{{filtro_grid_codici_selezionati}}
					</div>

					<v-card-actions class="py-5 pr-5">
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							v-on:click="btnDownloadTracceClick">
							Download Riquadri
						</v-btn>
						<v-btn
							color="primary"
							v-on:click="btnOpenSchedaMD">
							Scheda Metadati
						</v-btn>
					</v-card-actions>
				</v-card>

				<v-card class="card-section">
					<v-subheader>Selezionare Riquadro e Tipologia</v-subheader>
					<v-card-text style="display:flex;">

						<div class="mr-2 flex-1">
							<!--Filtro per FOGLIO -->
							<v-autocomplete
								class="input-select"
								v-model="filtro_grid"
								:disabled="loading"
								:items="listOfDtmForFilter_grid"
								clearable
								chips
								outlined
								color="blue-grey lighten-2"
								label="Filtro per riquadro"
								item-text="codiceGrid"
								item-value="codiceGrid"
								multiple
								hide-details>
								<template v-slot:selection="data">
									<v-chip
										v-bind="data.attrs"
										:input-value="data.selected"
										close
										@click="data.select"
										@click:close="removeChipGrid(data.item)">
										{{ data.item.codiceGrid }}
									</v-chip>
								</template>
								<template v-slot:item="data">
									<template>
										<v-list-item-title v-text="data.item.codiceGrid"></v-list-item-title>
									</template>
								</template>
							</v-autocomplete>
						</div>

						<!--Filtro per TIPO -->
						<div class="mr-2 flex-1">
							<v-autocomplete
								class="input-select"
								v-model="filtro_tipo"
								:disabled="loading"
								:items="listOfDtmForFilter_tipo"
								clearable
								chips
								outlined
								color="blue-grey lighten-2"
								label="Filtro per Tipologia"
								item-text="tipo"
								item-value="tipo"
								multiple
								hide-details>
								<template v-slot:selection="data">
									<v-chip
										v-bind="data.attrs"
										:input-value="data.selected"
										close
										@click="data.select"
										@click:close="removeChipTipo(data.item)">
										{{ data.item.tipo }}
									</v-chip>
								</template>
								<template v-slot:item="data">
									<template>
										<v-list-item-title v-text="data.item.tipo"></v-list-item-title>
									</template>
								</template>
							</v-autocomplete>
						</div>
					</v-card-text>

					<v-card-actions class="pb-5 pr-5" >
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							v-on:click="doFilter">
							Esegui Filtro
						</v-btn>
						<v-btn
							color="primary"
							v-bind:disabled="!filterButtonsEnabled"
							v-on:click="resetFilter">
							Reset
						</v-btn>
					</v-card-actions>
					
				</v-card>

				<v-card class="card-section">
					<v-card-text>
						<div>ATTENZIONE: è possibile scaricare più file contemporaneamente ({{ numDownloadMax }} file) ma è necessario verificare il limite di download simultanei consentiti dal browser.</div>
					</v-card-text>
					
					<v-card-actions class="pt-5 pl-5">
						<!--Select and unselect all rows-->
						<v-btn
							color="primary"
							v-on:click="selectAllRows">
							Seleziona tutto
						</v-btn>
						<v-btn
							color="primary"
							v-on:click="unselectAllRows">
							Rimuovi selezione
						</v-btn>

						<!-- Download dati selezionate -->
						<v-btn
							color="primary"
							:disabled="!showDownloadBtn"
							v-on:click="showDialogDownload">
							Download
						</v-btn>
					</v-card-actions>

					<v-card-text>
						<v-subheader>Selezionare il dato da scaricare</v-subheader>
						<v-subheader class="maxdownload" v-if="maxDownloadFileExcedeed">Si è superato il numero massimo di {{numDownloadMax}} file scaricabili</v-subheader>
						<v-data-table
							v-model="selectedRows"
							:headers="gridHeaders"
							:items="gridData"
							:items-per-page="gridPageItems"
							:search="gridSearch"
							:loading="loading"
							@click:row="rowClick"
							@toggle-select-all="toggleAllRows"
							show-select
							loading-text="Caricamento dati. Attendere...">
						</v-data-table>

						<div v-if="debugEnabled">
							IDs of selected rows: {{selectedRows}}
						</div>
					</v-card-text>
				</v-card>

			</v-card-text>	
			
		</v-card>

		<FileDownloader v-if="listDownload.length > 0"
			v-bind:prop_list_download="listDownload"
			v-on:download_completed="listDownload = []">
		</FileDownloader>

	</div>

</template>

<style scoped>
	.details-campagna {
		height: 36px;
	}

	.v-text-field.v-text-field--enclosed {
		margin-top: 5px;
	}

	.minimappa {
		position: relative;
		height: 500px;
	}

	.card-section {
		margin-bottom: 15px !important;
	}

	.maxdownload {
		color: red !important;
	}

</style>

<style>
	.input-select .v-select__selections {
		min-height: 54px !important;
	}
</style>

<script>
import { DEBUG_CONFIG } from "@/configs/debugConfig.js";
import { EventBus } from '@/components/EventBus';
const { Utils } = require('@/assets/js/scripts/utils/Utils');
const { RequestsUtils } = require("@/assets/js/scripts/utils/RequestsUtils");
const { PiwikSIGMA } = require('@/assets/js/scripts/piwik/PiwikSIGMA');

import FileDownloader from "@/components/widgets_utils/FileDownloader";
import MiniMappa from "@/components/minimappa/MiniMappa";

export default {
	name: 'DtmContent',
	props: [
		'prop_map_config'
	],

	components: {
		MiniMappa,
		FileDownloader,
	},

	created() {

		EventBus.$on("campagna_selected", (campagna) => {
			this.campagna = campagna;
			this.requestQuadroUnioneFeatures(campagna.id);
			this.requestDtmData(campagna.id);
		});

	},

	data() {
		return {
			
			debugEnabled: DEBUG_CONFIG.DEBUG_DOWNLOAD,
			
			numDownloadMax: 20,

			quadrounione_features: [],
			campagna: null,

			/*
			configurazioneMappa : {
				epsg: "EPSG:3857",
				centerCoordsWGS84: [12.8306, 45.7829],
				initZoom: 10,
				// layers: [
				// 	{
				// 		url: 'http://sigma.genegis.it:80/geoserver/sigma/wms',
				// 		layerName: 'sigma:test_quadro_unione',
				// 		format: 'image/png',
				// 	}
				// ],
				//Per VEC
				attributeFieldForSelect: "cod_grid"
			},
			*/

			configurazioneMappa: null,

			/*
			Filtri
			*/
			filtro_grid: [],
			filtro_tipo: [],
			gridData_Original: [],

			/*
			 * Dati da mappa
			 */
			selezioneMappa: [],

			/* GRID*/
			loading: true,
			gridHeaders: [
				// { text: 'ID', value: 'id' },
				{ text: 'Riquadro', value: 'cod_grid'},
				{ text: 'Tipo', value: 'tipo' },
			],
			gridSearch: '',
			gridData: [],
			gridPageItems: 10,
			selectedRows: [],

			listDownload: [],
		}
	},

	computed: {
		maxDownloadFileExcedeed: function() {
			if (this.selectedRows.length > this.numDownloadMax) {
				return true;
			}
			else {
				return false;
			}
		},

		filtro_grid_codici_selezionati: function() {
			var codiciSelezionati = this.filtro_grid;
			return codiciSelezionati;
		},

		listOfDtmForFilter_grid: function() {
			
			//Dati dalle Features
			let list = this.quadrounione_features.map(feat => feat.properties["cod_grid"]);
			
			let uniques = list.filter(function(value, idx, self){
				return self.indexOf(value) === idx;
			});
			
			uniques = uniques.sort();
			
			var res = uniques.map(function(val){
				return {
					"codiceGrid" : val
				};
			});
			
			return res;
		},

		listOfDtmForFilter_tipo: function() {
			
			let list = this.gridData_Original.map(x => x.tipo);
			
			let uniques = list.filter(function(value, idx, self){
				return self.indexOf(value) === idx;
			});
			
			uniques = uniques.sort();
			
			var res = uniques.map(function(val){
				return {
					"tipo" : val
				};
			});
			
			return res;
		},

		filterButtonsEnabled: function() {
			return this.filtroSpecificato();
		},

		showDownloadBtn: function() {
			return (this.selectedRows.length > 0) && !this.maxDownloadFileExcedeed;
		},
	},

	methods: {

		filtroSpecificato() {
			let gridSpecificato = (!Utils.isNullOrUndefined(this.filtro_grid) && this.filtro_grid.length > 0);
			let tipoSpecificato = (!Utils.isNullOrUndefined(this.filtro_tipo) && this.filtro_tipo.length > 0);
			return gridSpecificato || tipoSpecificato;
		},

		matchGrid(item) {
			//se filtro non impostato matcha
			if (Utils.isNullOrUndefined(this.filtro_grid) || this.filtro_grid.length == 0) {
				return true;
			}
			if (this.filtro_grid.indexOf(item.cod_grid) > -1) {
				return true;
			}
			return false;
		},

		matchTipo(item) {
			//se filtro non impostato matcha
			if (Utils.isNullOrUndefined(this.filtro_tipo) || this.filtro_tipo.length == 0) {
				return true;
			}
			if (this.filtro_tipo.indexOf(item.tipo) > -1) {
				return true;
			}
			return false;
		},

		toggleAllRows: function(evntObj) {
			if (!Utils.isNullOrUndefined(evntObj)) {
				if (evntObj.value === true) {
					this.selectAllRows();
				} else {
					this.unselectAllRows();
				}
			}
		},

		selectAllRows: function() {
			this.selectedRows = this.gridData;
		},

		unselectAllRows: function() {
			this.selectedRows = [];
		},

		doFilter: function() {
			if (this.filtroSpecificato() == true) {
				//specificato filtro -> faccio filtro
				let datiOriginali = this.gridData_Original;
				let datiFiltrati = [];
				datiOriginali.forEach(item => {
					let filterSatisfied = this.matchGrid(item) && this.matchTipo(item);
					if (filterSatisfied == true) {
						datiFiltrati.push(item);
					}
				});
				this.gridData = datiFiltrati;

			}
			else {
				//Non specificato filtro -> mostro originali
				this.gridData = this.gridData_Original;
			}
		},

		resetFilter: function() {
			//Rimuovo la selezione dalla tabella
			this.unselectAllRows();
			
			this.filtro_grid = [];
			this.filtro_tipo = [];
			
			//apply new (empty) filters:
			this.doFilter();
		},

		rowClick: function (item, row) {
			row.select(!row.isSelected);
		},

		removeChipGrid(item) {
			let index = this.filtro_grid.indexOf(item.codiceGrid)
        	if (index >= 0) this.filtro_grid.splice(index, 1)
      	},
		removeChipTipo(item) {
			let index = this.filtro_tipo.indexOf(item.tipo)
        	if (index >= 0) this.filtro_tipo.splice(index, 1)
		},

		showDialogDownload() {
			
			// //Check numero download
			// if (this.selectedRows.length > this.numDownloadMax) {
				
			// 	let msg = "Il numero massimo di download consentiti è " + this.numDownloadMax;
			// 	EventBus.$emit('open_dialog_error', {
			// 		message: msg,
			// 		title: 'Attenzione'
			// 	});

			// } else {
			let msg = "Scaricare " + this.selectedRows.length + " rilievi selezionati?"
			EventBus.$emit('open_dialog_confirm', {
				message: msg,
				actions: {
					onConfirm: (function() {
						this.downloadSelectedRows();

					}).bind(this)
				}
			});
			// }
		},

		downloadSelectedRows() {
			var selectedRows = this.selectedRows;
			
			//Chiamo piwik per le statistiche
			try {
				for(let row of selectedRows) {
					/*
					* Invia statistica Download DTM
					*/
					let codCamp = this.campagna.codice;
					let tipo = row.tipo;
					PiwikSIGMA.inviaStatisticaDownloadDTM(row.tipo);	
				}
			} catch(error) {
				console.error("Errore chiamata Piwik");
			}

			if (!Utils.isNullOrUndefined(selectedRows) && selectedRows.length > 0) {
				let listDownload = [];
				for(let row of selectedRows) {
					listDownload.push({
						url: '../dtm/getFile',
						id: row.id,
						name: row.fileName,
					});

					//this.requestDownloadDtm(row.id, row.fileName);
				}

				// Imposta la lista di file da scaricare da passare al widget download file
				this.listDownload = listDownload;
			}
		},

		/*
		requestDownloadDtm(id, name) {
			RequestsUtils.post('../dtm/getFile', 
				// Params
				{
					id: id
				}, 
				// Success Callback
				(function(response) {

					const type = response.headers['content-type'];
					const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' });
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					const fileName =  name // whatever your file name .
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();

				}).bind(this),
				// Fail Callback
				null,
				// Show Message success
				false,
				// Show Loading
				true,
				// Response Type
				'blob'
			);
		},
		*/

		requestDtmData(campagnaId) {
			RequestsUtils.get(
				"../dtm/getDtm",
				// Params
				{
					campagnaId: campagnaId
				},
            // Success Callback
            function (response) {
			      let data = response.data.result;

					//Metto i dati in pancia a vue
					this.gridData_Original = data;
					this.gridData = data;
					this.loading = false;
            }.bind(this),
            // Fail Callback
            null,
            // Show Message success
            false,
            // Show Loading
            true
         );
		},

		requestQuadroUnioneFeatures(campagnaId) {
			RequestsUtils.get(
            "../dtm/getDtmQuadroUnioneFeatures",
            // Params
            {
					campagnaId: campagnaId
				},
            // Success Callback
            function (response) {
			      this.quadrounione_features = response.data.result;
            }.bind(this),
            // Fail Callback
            null,
            // Show Message success
            false,
            // Show Loading
            true
         );
		},

		btnDownloadTracceClick: function() {
			var vue = this;
			var url = "../dtm/downloadTracceCampagnaDT?campagnaId=" + this.campagna.id;
			location.href = url;
		},

		btnOpenSchedaMD: function() {
			//alert('apro sch MD');
			RequestsUtils.get(
				"../dtm/getTracceMdUrl",
				// Params
				{
					campagnaId: this.campagna.id
				},
				// Success Callback
				function (response) {
					if (!Utils.isNullOrUndefined(response.data.result)) {
						var mdUrl = response.data.result;
						window.open(mdUrl, '_blank');
					}
					else {
						//Errore, MD nn presente
						EventBus.$emit('open_dialog_success', {
							message: "Le tracce della campagna selezionata non hanno un metadato associato"
						});
					}
				}.bind(this),
				// Fail Callback
				null,
				// Show Message success
				false,
				// Show Loading
				true
			);
		}

	},

	watch: {
		selezioneMappa: {
			immediate : true, 
			handler: function(newList, oldVal) {
				//Aggiorno il filtro....
				
				var selection = [];
				if (!Utils.isNullOrUndefined(newList)) {
					
					var uniques = newList.filter(function(value, idx, self){
						return self.indexOf(value) === idx;
					});

					selection = uniques;
				}
				
				//Aggiorna il filtro
				this.filtro_grid = selection;
			}
		},

		prop_map_config: {
			immediate : true, 
			handler(val, oldVal) {
				if(val != null) {
					this.configurazioneMappa = val;
				}
			}
		},

		gridData: {
			immediate : true, 
			handler(val, oldVal) {
				if(val != null) {
					this.unselectAllRows();
				}
			}
		}
	}
}
</script>